export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-01.55e7271b.jpg";